export default {
  allDay: 'Ganztägig',
};
